<template>
  <div
    class="z-20 text-center text-white lg:text-left py-6 px-3 md:pr-4 md:pt-8 md:pl-16 md:pb-8"
  >
    <p class="mb-2 font-bold ds-text-2xl">No video...yet</p>
    <p class="mb-4 ds-text-base font-regular">
      Athletes with video get 5x more exposure to college coaches.
    </p>
    <a
      href="/video"
      @click="trackClick"
      class="inline xs:inline-block xs:mx-auto"
    >
      <Button text="Upload Video" :short="true" />
    </a>
  </div>
</template>

<script>
import { Button } from '@sportsrecruits/playbook';
import api from "@/services/api";
export default {
  components: {
    Button,
  },
  methods: {
    trackClick() {
      var props = {};
      props.site_access_id = api.clientData().site_access_id;
      props.page = window.location.href;
      props.cta_name = "profile_preview_header";
      window.SrSegment.track("upload_video_cta", props);
    },
  },
};
</script>

<style scoped>
</style>